
import React from 'react';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { AlertTriangle } from 'lucide-react';

interface Client {
  id: number;
  legal_name: string;
  company_tax_id: string;
}

interface ClientDeleteDialogProps {
  client: Client;
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export const ClientDeleteDialog: React.FC<ClientDeleteDialogProps> = ({ 
  client, 
  isOpen, 
  onClose, 
  onConfirm 
}) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="bg-gray-900 border-red-500/20 text-white max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center text-red-400">
            <AlertTriangle className="w-6 h-6 mr-2" />
            Confirmar Exclusão
          </DialogTitle>
          <DialogDescription className="text-gray-300">
            Esta ação não pode ser desfeita. Tem certeza de que deseja excluir este cliente?
          </DialogDescription>
        </DialogHeader>

        <div className="bg-red-900/20 border border-red-500/30 rounded-lg p-4 my-4">
          <div className="space-y-2">
            <p className="text-white font-medium">{client.legal_name}</p>
            <p className="text-gray-400 text-sm font-mono">{client.company_tax_id}</p>
          </div>
        </div>

        <DialogFooter className="space-x-2">
          <Button
            variant="outline"
            onClick={onClose}
            className="border-green-500/30 text-white hover:bg-green-900/20"
          >
            Cancelar
          </Button>
          <Button
            onClick={onConfirm}
            className="bg-red-600 hover:bg-red-700 text-white"
          >
            Excluir Cliente
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
